import { ref } from "vue";
import { useStore } from "vuex";

export function useEpiValidation() {
  const store = useStore();
  const loading = ref(false);

  const hasPermission = (permission) => {
    const userPermissions =
      store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];
    return userPermissions.includes(permission);
  };

  const validateUserForInclusion = async (
    userId,
    unidadeId,
    isTerceiro = false
  ) => {
    if (isTerceiro) {
      return {
        canInclude: true,
        showWarning: false,
        message: "",
        epiData: [],
      };
    }

    if (!userId) {
      return {
        canInclude: true,
        showWarning: false,
        message: "",
        epiData: [],
      };
    }

    try {
      loading.value = true;

      const temPermissaoExibirStatus = hasPermission("pdt-exibir-status-troca");
      const temPermissaoValidarInclusao = hasPermission(
        "pdt-validar-inclusao-status-troca"
      );
      const temPermissaoValidarInclusaoCritica = hasPermission(
        "pdt-validar-inclusao-status-troca-critico"
      );

      const responseRegra = await store.state.autenticacao.apiLegado.get(
        `/product-groups/report`,
        {
          params: {
            page: 1,
            per_page: 50,
            vendor_id: unidadeId,
            user_id: userId,
          },
        }
      );

      let todosEpis = [];
      if (responseRegra.data?.results?.data) {
        todosEpis = responseRegra.data.results.data;
      } else if (responseRegra.data?.result?.data) {
        todosEpis = responseRegra.data.result.data;
      } else if (
        responseRegra.data?.result &&
        Array.isArray(responseRegra.data.result)
      ) {
        todosEpis = responseRegra.data.result;
      } else if (responseRegra.data?.data) {
        todosEpis = responseRegra.data.data;
      }

      if (!todosEpis || todosEpis.length === 0) {
        if (temPermissaoExibirStatus) {
          return {
            canInclude: true,
            showWarning: false,
            message: "",
            epiData: [],
          };
        } else {
          return {
            canInclude: true,
            showWarning: true,
            message:
              "O funcionário não possui regra na unidade de emissão da PT",
            epiData: [],
          };
        }
      }

      const responseVencidos = await store.state.autenticacao.apiLegado.get(
        `/product-groups/report`,
        {
          params: {
            page: 1,
            per_page: 50,
            vendor_id: unidadeId,
            user_id: userId,
            status: "atrasado",
          },
        }
      );

      let episVencidos = [];
      if (responseVencidos.data?.results?.data) {
        episVencidos = responseVencidos.data.results.data;
      } else if (responseVencidos.data?.result?.data) {
        episVencidos = responseVencidos.data.result.data;
      } else if (
        responseVencidos.data?.result &&
        Array.isArray(responseVencidos.data.result)
      ) {
        episVencidos = responseVencidos.data.result;
      } else if (responseVencidos.data?.data) {
        episVencidos = responseVencidos.data.data;
      }

      if (episVencidos.length === 0) {
        return {
          canInclude: true,
          showWarning: false,
          message: "",
          epiData: [],
        };
      }

      const temEpisCriticos = episVencidos.some(
        (item) =>
          item.critico === true ||
          item.critico === 1 ||
          item.critico === "1" ||
          item.critico === "true" ||
          item.regra_critica === true ||
          item.regra_critica === 1
      );

      const message =
        "O funcionário possui retirada de EPIs vencidos, regularize a retirada dos EPIs para realizar o trabalho";

      const shouldShowWarning = !temPermissaoExibirStatus;

      let canInclude = true;

      if (temEpisCriticos) {
        canInclude = temPermissaoValidarInclusaoCritica;
      } else {
        canInclude = temPermissaoValidarInclusao;
      }

      const result = {
        canInclude,
        showWarning: shouldShowWarning,
        message,
        epiData: episVencidos,
        hasCriticalItems: temEpisCriticos,
      };

      return result;
    } catch (error) {
      const temPermissaoExibirStatus = hasPermission("pdt-exibir-status-troca");

      if (temPermissaoExibirStatus) {
        return {
          canInclude: true,
          showWarning: false,
          message: "",
          epiData: [],
        };
      } else {
        return {
          canInclude: true,
          showWarning: true,
          message:
            "Erro ao verificar EPIs do funcionário. Verifique manualmente antes de prosseguir.",
          epiData: [],
        };
      }
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    validateUserForInclusion,
    hasPermission,
  };
}
